import { popupOpened } from '@pressreader/popups-core';

import { BLOCKED_USERS_DIALOG_NAME } from '../constants';

export function isBlockedUsersPopupOpenedAction(action: ReturnType<typeof popupOpened>) {
    const { type, name } = action.payload.popup;
    return type === 'dialog' && name === BLOCKED_USERS_DIALOG_NAME;
}
